"use client"

import type React from "react"

import { useTranslations } from "next-intl"

interface BackButtonProps {
  onClick: () => void
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  const t = useTranslations("common")
  return (
    <button type="button" aria-label={t("goBack")} className="text-fg-brand mx-4 transition-colors" onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
    </button>
  )
}
